function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgForwardArrowIcon = function SvgForwardArrowIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 15,
    viewBox: "0 0 8 15",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "nonzero",
    d: "M7.056 6.08L1.586.284C1.204-.116.61-.089.252.338-.103.765-.08 1.433.301 1.86l5.328 5.662-5.28 5.609c-.381.4-.405 1.068-.048 1.522.19.213.428.347.69.347.238 0 .452-.107.642-.294L7.08 8.938c.333-.374.523-.855.523-1.39 0-.587-.19-1.094-.547-1.468z"
  }));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgForwardArrowIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/forward_arrow_icon.6adcefdb.svg";
export { ForwardRef as ReactComponent };